import { useEffect } from 'react'
import { Flex } from '@chakra-ui/react'
import { addDays, format, parse } from 'date-fns'

import { useCustomFormViewer } from '../../../contexts/CustomFormViewerManager/Provider'
import CustomFormViewerQuestion from '../../../components/CustomFormViewerQuestion'

export default function CancelamentoAlteracaoDeFerias() {
  const { questions, formMethods } = useCustomFormViewer()
  const { watch, setValue } = formMethods

  const titleForQuestion = Object.fromEntries(questions.map((q) => [q.title, q.slug]))

  //PERIODO 1
  const periodo1Inicio = watch
    ? watch(`form_answers.${titleForQuestion['Data de início do período a ser cancelado']}`)
    : undefined
  const periodo1QuantidadeDias = watch
    ? watch(`form_answers.${titleForQuestion['Quantidade de dias do período a ser cancelado']}`)
    : undefined
  //PERIODO 2
  const desejaSolicitarNovoPeriodo = watch
    ? watch(`form_answers.${titleForQuestion['Deseja solicitar novo período?']}`)
    : undefined
  const periodo2Inicio = watch ? watch(`form_answers.${titleForQuestion['Data de Início']}`) : undefined
  const periodo2QuantidadeDias = watch ? watch(`form_answers.${titleForQuestion['Quantidade de dias']}`) : undefined

  //PERIODO 1
  useEffect(() => {
    if (periodo1Inicio && !isNaN(periodo1QuantidadeDias)) {
      try {
        const parsedDate = parse(periodo1Inicio, 'dd/MM/yyyy', new Date())
        const finalDate =
          periodo1QuantidadeDias == ''
            ? addDays(parsedDate, Number(periodo1QuantidadeDias))
            : addDays(parsedDate, Number(periodo1QuantidadeDias) - 1)
        const formatted = format(finalDate, 'dd/MM/yyyy')

        setValue(`form_answers.${titleForQuestion['Data fim do período a ser cancelado']}`, formatted)
      } catch (err) {
        // Data inválida
        setValue(`form_answers.${titleForQuestion['Data fim do período a ser cancelado']}`, '')
      }
    }
  }, [periodo1Inicio, periodo1QuantidadeDias, setValue])

  //PERIODO 2
  useEffect(() => {
    if (desejaSolicitarNovoPeriodo == 'Sim') {
      if (periodo2Inicio && !isNaN(periodo2QuantidadeDias)) {
        try {
          const parsedDate = parse(periodo2Inicio, 'dd/MM/yyyy', new Date())
          const finalDate =
            periodo2QuantidadeDias == ''
              ? addDays(parsedDate, Number(periodo2QuantidadeDias))
              : addDays(parsedDate, Number(periodo2QuantidadeDias) - 1)
          const formatted = format(finalDate, 'dd/MM/yyyy')

          setValue(`form_answers.${titleForQuestion['Data de Fim']}`, formatted)
        } catch (err) {
          // Data inválida
          setValue(`form_answers.${titleForQuestion['Data de Fim']}`, '')
        }
      }
    } else {
      setValue(`form_answers.${titleForQuestion['Data de Início']}`, '')
      setValue(`form_answers.${titleForQuestion['Quantidade de dias']}`, '')
      setValue(`form_answers.${titleForQuestion['Data de Fim']}`, '')
      setValue(`form_answers.${titleForQuestion['Deseja converter dias de férias em abono pecuniário?']}`, '')
      setValue(`form_answers.${titleForQuestion['Se sim, quantos dias']}`, '')
      setValue(`form_answers.${titleForQuestion['Deseja receber adiantamento de 13º salário?']}`, '')
      setValue(
        `form_answers.${titleForQuestion['Anuência do Coordenador e do Gestor de alteração/cancelamento de férias']}`,
        ''
      )
    }
  }, [desejaSolicitarNovoPeriodo, periodo2Inicio, periodo2QuantidadeDias, setValue])

  if (!questions) return null

  return (
    <Flex bg="transparent" flexDir="column" gap={2} borderTop="1px solid" borderColor="primary">
      {questions.map((question, index) => {
        //PERIODO 2
        if (
          question.title == 'Data de Início' ||
          question.title == 'Quantidade de dias' ||
          question.title == 'Data de Fim' ||
          question.title == 'Deseja converter dias de férias em abono pecuniário?' ||
          question.title == 'Deseja receber adiantamento de 13º salário?' ||
          question.title == 'Anuência do Coordenador e do Gestor de alteração/cancelamento de férias'
        ) {
          if (desejaSolicitarNovoPeriodo != 'Sim') {
            return <></>
          }
        }

        //PERIODO 2
        if (question.title == 'Se sim, quantos dias') {
          if (desejaSolicitarNovoPeriodo != 'Sim') {
            return <></>
          } else {
            const totalDias = Number(periodo1QuantidadeDias) + Number(periodo2QuantidadeDias)
            const maxDias = Math.floor(totalDias / 3)
            const newQuestionValues = {
              ...question,
              description: question?.description?.concat(' ', `Máximo: ${maxDias}`),
              validation: { ...question.validation, max: maxDias },
            }

            return (
              <CustomFormViewerQuestion
                key={index}
                index={index}
                questionsLength={questions.length}
                question={newQuestionValues}
                disabled={false}
              />
            )
          }
        }

        return (
          <CustomFormViewerQuestion
            key={index}
            index={index}
            questionsLength={questions.length}
            question={question}
            disabled={false}
          />
        )
      })}
    </Flex>
  )
}
